import { AbstractControl, ValidationErrors } from '@angular/forms';

export function sinValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  const invalidSin = { invalidSin: $localize`Invalid SIN` };

  // remove all spaces and dashes
  const cleanedSin = control.value.replace(/[-\s]/g, '');

  if (cleanedSin.length !== 9 || isNaN(Number(cleanedSin))) {
    return invalidSin;
  }

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    let digit = parseInt(cleanedSin[i], 10);

    if (i % 2 === 1) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    sum += digit;
  }

  return sum % 10 === 0 ? null : invalidSin;
}
